
























































import {Component, Prop, Vue} from 'vue-property-decorator'
import {$, ID, successAndPush} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import _ from 'lodash'
import OcultarNotasResponsavel from '@/model/resource/OcultarNotasResponsavel'

const metaInfo = () => ({
  title: $.t('view.persist.hideResponsavelNotasPersist.title'),
})

@Component({
  metaInfo,
})
export default class HideResponsavelNotasPersistView extends Vue {
  @Prop({type: [String, Number]}) id?: ID

  AppConfig = AppConfig

  listToPersist: OcultarNotasResponsavel[] = []

  persistThrottled = _.throttle(() => this.persist(), 7000)

  created() {
    this.$set(this.listToPersist, 0, new OcultarNotasResponsavel())
  }

  async mounted() {
    if (this.id) await this.listToPersist[0].getOcultarNotasResponsavel(this.id)
    $.await.done('getOcultarNotasResponsavel')
  }

  addItem() {
    this.listToPersist.push(new OcultarNotasResponsavel())
  }

  removeItem(item: OcultarNotasResponsavel) {
    const index = this.listToPersist.indexOf(item)
    if (index > -1) {
      this.listToPersist.splice(index, 1)
      this.$forceUpdate()
    }
  }

  async persist() {
    await OcultarNotasResponsavel.persistLoteOcultarNotasResponsavel(this.listToPersist)
    successAndPush('system.success.persist', '/manage/hide-responsavel-notas/list')
  }

}
